import { useState } from 'react';
import type { PlaylistItem } from '@jwp/ott-common/types/playlist';

import useMedia from './useMedia';

export default function useTrailerData(item: PlaylistItem | undefined) {
  const [isTrailerPlaying, setIsTrailerPlaying] = useState<boolean>(false);
  const hasTrailer = !!item?.trailerId;
  const { isLoading: isTrailerLoading, data: trailerItem } = useMedia(item?.trailerId || '');

  const playTrailer = () => setIsTrailerPlaying(true);
  const closeTrailer = () => setIsTrailerPlaying(false);

  const trailerTitle = item ? `${item?.title} - Trailer` : 'Trailer';

  return {
    isTrailerPlaying,
    isTrailerLoading,
    trailerItem,
    trailerTitle,
    hasTrailer,
    playTrailer,
    closeTrailer,
  };
}
